import React from 'react';
import { Typography, AppBar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import VideoPlayer from './components/VideoPlayer';
import Notifications from './components/Notifications';
import SideBar from './components/SideBar';


const useStyles = makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: '30px 100px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '600px',
    border: '4px solid black',

    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
 

}));

 const App = () => {
//     class App extends Component {
//         constructor(props) {
//           super(props);
//           this.state = {
//             windowWidth: 0,
//             windowHeight: 0
//           };
//         }
      
//         componentDidMount() {
//           this.updateDimensions();
//           window.addEventListener("resize", this.updateDimensions.bind(this));
//         }
      
//         componentWillUnmount() {
//           window.removeEventListener("resize", this.updateDimensions.bind(this));
//         }
      
//         updateDimensions() {
//           let windowWidth = typeof window !== "undefined" ? window.innerWidth : 0;
//           let windowHeight = typeof window !== "undefined" ? window.innerHeight : 0;
      
//           this.setState({ windowWidth, windowHeight });
//         }
//     };
  const classes = useStyles();

  return (
      <div class="area" >
            <ul class="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
     <div className={classes.wrapper} >
      <AppBar className={classes.appBar} position="static" >
        <Typography variant="h1" align="center" class="context" >ROGO APP</Typography>
      </AppBar>
    </div >
      <VideoPlayer />
       <SideBar>
        <Notifications />
    </SideBar>
    </div>
  );
};

export default App;